import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-759076fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src", "title"]

import { reactive } from "@vue/reactivity";
//import { onMounted } from "@vue/runtime-core";
import axios from "axios";

// user type interface
interface User {
  name: string;
  surname: string;
  email: string;
  gender: string;
  picture: string;
}
//state

export default /*#__PURE__*/_defineComponent({
  __name: 'UserGenerator',
  setup(__props) {

//import
const state: User = reactive({
  name: "John",
  surname: "Doe",
  email: "john@gmail.com",
  gender: "male",
  picture: "https://randomuser.me/api/portraits/men/11.jpg",
});
//

//get random user
const getUser = () => {
  axios.get("https://randomuser.me/api").then((res) => {
    state.name = res.data.results[0].name.first;
    state.surname = res.data.results[0].name.last;
    state.email = res.data.results[0].email;
    state.gender = res.data.results[0].gender;
    state.picture = res.data.results[0].picture.large;
  });
};

//onMounted(getUser) window loading api request

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: _normalizeClass(state.gender),
        src: state.picture,
        loading: "lazy",
        title: state.name
      }, null, 10, _hoisted_3),
      _createElementVNode("h1", null, _toDisplayString(state.name) + " " + _toDisplayString(state.surname), 1),
      _createElementVNode("h3", null, _toDisplayString(state.email), 1),
      _createElementVNode("button", {
        class: _normalizeClass(state.gender),
        onClick: getUser
      }, "Random User", 2)
    ])
  ]))
}
}

})